
'use strict';

import vex from 'vex-js';

const config = {
    clickEvents: 'click touch',
    closeBtnClass: 'vex-close-btn',
    closeTarget: '.vex-close, .vex-close-btn, .vex-close-link',
    modalContent: '[data-modal="faceted-search-modal"]',
    triggerTarget: '.js-filter-open',
    vexTheme: 'faceted-search-vex',
    displayBlock: 'u-block',
    searchInputClass : ".c-search__input",
    searchButtonReset : ".c-search__button--reset",
    expandableItemClass : ".c-expandable-item--custom",
    filterFormMobile: 'js-search-filter-form-mobile',

    form: '.js-search-filter-form',
    filter: ':checkbox'
};

class FacetedSearchModal {

    constructor() {
        if (!$(config.triggerTarget).length) {
            return;
        }
        this.prepareDom();
        this.setupClickEvents();
    }

    /**
     * Parses the HTML string representing the modal that's inside the <script> tag to
     * obtain a DOM sub-tree we can manipulate [almost] like the regular DOM.
     */
    prepareDom() {
        let modalContents = $(config.modalContent).html(); // This is the form
        this.loginUrl = '/designspark/login?return_to=';

        if (typeof this.modalContext === 'undefined') {
            this.modalContext = $(modalContents);
        }

        //change id on checkboxes and for on label to avoid conflict with desktop filters
        this.modalContext.find(config.filter).each(function() {
            let checkboxes = $(this);

            checkboxes.each(function() {
                let currentCheckbox = $(this);
                let currentLabel = currentCheckbox.next('label');

                currentCheckbox.attr('id', 'mobile_' + currentCheckbox.attr('id'));
                currentLabel.attr('for', currentCheckbox.attr('id'));

                return false;
            });
        });


        //Expands the expandable item if at least 1 box is checked on mobile
        this.modalContext.find(config.expandableItemClass).each(function() {
            let currentSection = $(this);
            let checkboxes = currentSection.find(config.filter);

            if (checkboxes.length > 0) {
                currentSection.removeAttr('open'); // Collapse on mobile by default
            }

            checkboxes.each(function() {
                if ($(this).is(':checked')) {
                    currentSection.attr('open', 'open');
                    return false;
                }
            });
        });
    }

    /**
     * Sets up all click events for the Modal component
     */
    setupClickEvents() {
        $(document).on(config.clickEvents, config.triggerTarget, (e) => this.handleOpenModal(e));
    }

    /**
     * Handles trigger for opening the modal
     *
     * @param {event} e
     */
    handleOpenModal(e) {
        e.preventDefault();
        e.stopPropagation();

        this.modalContext.addClass(config.displayBlock);
        this.modalContext.addClass(config.filterFormMobile);

        this.vex = vex.open({
            content: this.modalContext,
            className: config.vexTheme,
            closeClassName: config.closeBtnClass
        });

        $(config.searchButtonReset).click(function() {
            $(config.searchInputClass).removeAttr('value');
        });

        $(config.closeTarget, this.vex[0]).on(config.clickEvents, (e) => this.handleCloseDialog(e));
    }

    /**
     * Handler for when close is clicked
     *
     * @param {event} e
     */
    handleCloseDialog(e) {
        e.preventDefault();
        this.modalContext.removeClass(config.displayBlock);
        this.closeDialog();
    }

    /**
     * Closes the dialog associated with this instance
     */
    closeDialog() {
        vex.close(this.vex.data().vex.id);
    }
}

$(window).load(function(){
    new FacetedSearchModal();
});



// WEBPACK FOOTER //
// ./src/js/components/faceted-search-mobile.js